import React from 'react';

// GHS Pictograms (red diamond border, white interior, black icon)
function GHSFrame({ children, size = 56 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(45 50 50)">
        <rect x="15" y="15" width="70" height="70" fill="#ffffff" stroke="#dc2626" strokeWidth="6" />
      </g>
      {children}
    </svg>
  );
}

export function CorrosiveIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      <path d="M30 35 L34 50 L42 55 L46 60" stroke="#0a0a0a" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M28 35 Q30 30 32 32 Z" fill="#0a0a0a" />
      <path d="M40 60 Q50 55 60 60 L62 70 L40 70 Z" fill="#0a0a0a" />
      <path d="M40 60 Q42 50 50 50 Q58 50 60 60" fill="none" stroke="#0a0a0a" strokeWidth="2" />
      <path d="M65 30 Q67 25 69 27 Z" fill="#0a0a0a" />
      <path d="M65 35 L70 50 L78 55 Q72 65 65 60" stroke="#0a0a0a" strokeWidth="2.5" fill="none" />
      <path d="M55 65 L75 65" stroke="#0a0a0a" strokeWidth="3" />
      <path d="M58 65 L60 70" stroke="#0a0a0a" strokeWidth="2" />
      <path d="M62 65 L64 70" stroke="#0a0a0a" strokeWidth="2" />
      <path d="M66 65 L68 70" stroke="#0a0a0a" strokeWidth="2" />
      <path d="M70 65 L72 70" stroke="#0a0a0a" strokeWidth="2" />
    </GHSFrame>
  );
}

export function OxidizerIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      <circle cx="50" cy="60" r="10" fill="none" stroke="#0a0a0a" strokeWidth="3" />
      <path d="M44 45 Q46 38 50 30 Q54 38 56 45 Q58 48 56 52 Q53 55 50 52 Q47 55 44 52 Q42 48 44 45 Z" fill="#0a0a0a" />
      <path d="M28 70 L72 70" stroke="#0a0a0a" strokeWidth="3" />
    </GHSFrame>
  );
}

export function FlammableIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      {/* Flame */}
      <path
        d="M50 22 Q40 35 38 45 Q35 52 38 60 Q40 68 50 75 Q60 68 62 60 Q65 52 60 48 Q55 50 56 55 Q57 60 50 65 Q44 60 46 52 Q48 42 50 22 Z"
        fill="#0a0a0a"
      />
      <path d="M28 78 L72 78" stroke="#0a0a0a" strokeWidth="3" />
    </GHSFrame>
  );
}

export function ToxicIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      {/* Skull */}
      <ellipse cx="50" cy="48" rx="16" ry="14" fill="#0a0a0a" />
      <circle cx="44" cy="46" r="3" fill="#fff" />
      <circle cx="56" cy="46" r="3" fill="#fff" />
      <path d="M46 56 L50 60 L54 56" stroke="#fff" strokeWidth="2" fill="none" />
      <rect x="44" y="62" width="2" height="6" fill="#0a0a0a" />
      <rect x="48" y="62" width="2" height="6" fill="#0a0a0a" />
      <rect x="52" y="62" width="2" height="6" fill="#0a0a0a" />
      {/* Crossbones */}
      <path d="M30 70 L70 78" stroke="#0a0a0a" strokeWidth="3" />
      <path d="M30 78 L70 70" stroke="#0a0a0a" strokeWidth="3" />
      <circle cx="29" cy="70" r="3" fill="#0a0a0a" />
      <circle cx="71" cy="70" r="3" fill="#0a0a0a" />
      <circle cx="29" cy="78" r="3" fill="#0a0a0a" />
      <circle cx="71" cy="78" r="3" fill="#0a0a0a" />
    </GHSFrame>
  );
}

export function HealthHazardIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      {/* Person silhouette with star burst on chest */}
      <path d="M50 25 Q45 25 45 32 Q45 38 50 38 Q55 38 55 32 Q55 25 50 25 Z" fill="#0a0a0a" />
      <path d="M40 40 Q40 50 45 55 L45 75 L55 75 L55 55 Q60 50 60 40 Z" fill="#0a0a0a" />
      {/* Star burst */}
      <path
        d="M58 45 L62 48 L66 46 L65 50 L68 53 L64 54 L62 58 L60 54 L56 53 L59 50 L58 46 Z"
        fill="#fff"
        stroke="#0a0a0a"
        strokeWidth="1"
      />
    </GHSFrame>
  );
}

export function EnvironmentIcon({ size = 56 }) {
  return (
    <GHSFrame size={size}>
      {/* Tree */}
      <path d="M30 60 L40 35 L50 60 Z" fill="#0a0a0a" />
      <rect x="38" y="60" width="4" height="8" fill="#0a0a0a" />
      {/* Fish */}
      <ellipse cx="62" cy="65" rx="10" ry="5" fill="#0a0a0a" />
      <path d="M70 65 L78 60 L78 70 Z" fill="#0a0a0a" />
      <circle cx="58" cy="63" r="1.5" fill="#fff" />
      {/* Water line */}
      <path d="M28 75 Q40 72 52 75 Q64 78 76 75" stroke="#0a0a0a" strokeWidth="2" fill="none" />
    </GHSFrame>
  );
}

export function GHSIconRenderer({ symbols = [], size = 50 }) {
  if (!symbols || symbols.length === 0) {
    return <span className="text-slate-400 text-2xl font-bold">—</span>;
  }
  const map = {
    corrosive: CorrosiveIcon,
    oxidizer: OxidizerIcon,
    flammable: FlammableIcon,
    toxic: ToxicIcon,
    'health-hazard': HealthHazardIcon,
    environment: EnvironmentIcon,
  };
  return (
    <div className="flex items-center justify-center gap-1 flex-wrap">
      {symbols.map((s, idx) => {
        const Icon = map[s];
        return Icon ? <Icon key={idx} size={size} /> : null;
      })}
    </div>
  );
}

export const GHS_SYMBOL_OPTIONS = [
  { id: 'corrosive', label: 'آكال (Corrosive)', labelEn: 'Corrosive' },
  { id: 'oxidizer', label: 'مؤكسد (Oxidizer)', labelEn: 'Oxidizer' },
  { id: 'flammable', label: 'قابل للاشتعال', labelEn: 'Flammable' },
  { id: 'toxic', label: 'سام', labelEn: 'Toxic' },
  { id: 'health-hazard', label: 'خطر صحي', labelEn: 'Health hazard' },
  { id: 'environment', label: 'خطر بيئي', labelEn: 'Environmental hazard' },
];
